export default "__VITE_ASSET__DNACUUm6__"